// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__v9TZa","title":"BackImages_title__1zB0z","images":"BackImages_images__3jDxa"};